import { auth } from '../firebase';
import { trackEvent } from '../plugins/analytics';
import { GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';

const provider = new GoogleAuthProvider();

class AuthService {
    constructor() {
        this.user = null;
        this.initialized = false;
    }

    /**
     * Subscribe to auth state changes
     * @param {Function} callback - Function to call on state change
     * @returns {Function} unsubscribe function
     */
    onAuthStateChanged(callback) {
        return onAuthStateChanged(auth, (user) => {
            this.user = user;
            callback(user);
        });
    }

    /**
     * Login with Google
     */
    async loginWithGoogle() {
        try {
            const result = await signInWithPopup(auth, provider);
            this.user = result.user;
            trackEvent('login', { method: 'google' });
            return { success: true, user: this.user };
        } catch (error) {
            console.error("Error signing in with Google", error);
            return { success: false, error };
        }
    }

    /**
     * Logout
     */
    async logout() {
        try {
            await signOut(auth);
            this.user = null;
            return true;
        } catch (error) {
            console.error("Error signing out", error);
            return false;
        }
    }

    /**
     * Get current user
     */
    getCurrentUser() {
        return this.user;
    }

    /**
     * Check if user is logged in
     */
    isLoggedIn() {
        return !!this.user;
    }
}

export default new AuthService();
